function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.16 2.16a.545.545 0 01.771 0L8 7.229l5.069-5.07a.545.545 0 11.771.772L8.771 8l5.07 5.069a.545.545 0 11-.772.771L8 8.771l-5.069 5.07a.545.545 0 11-.771-.772L7.229 8l-5.07-5.069a.545.545 0 010-.771z",
  fill: "#2D2D2D"
});
function SvgCruz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Cruz.svg";
export { SvgCruz as ReactComponent };